// Module
var code = `<div class="row">
	<div class="col-md-4">
		<table class="table">
			<tr>
				<th>Property</th>
				<th>Type</th>
			</tr>
			<tr ng-repeat="(prop, prop_info) in event.description">
				<td>{{prop}}</td>
				<td>{{prop_info.type}} {{prop_info.default_type}} {{prop_info.default_expression}}</td>
			</tr>
		</table>
	</div>
	<div class="col-md-8">
		<a class="btn btn-success btn-xs" ng-click="create_table()">create_table</a>
		<a class="btn btn-warning btn-xs" ng-click="recreate_distributed()">recreate_distributed</a>
		<a class="btn btn-danger btn-xs" ng-click="drop_table()">drop_table</a>
		<pre>
			{{actions_logs | prettyJSON}}
		</pre>
	</div>
</div>

<div class="row">
	<div class="col-md-12">
		<label for="create_query">Create Query</label>
		<pre id="create_query"> - "{{event.create_query}}"</pre>

		<label for="drop_query">Drop Query</label>
		<pre id="drop_query"> - "{{event.drop_query}}"</pre>

		<label for="create_distributed_query">Create Distributed Query</label>
		<pre id="create_distributed_query"> - "{{event.create_distributed_query}}"</pre>

		<label for="drop_distributed_query">Drop Distributed Query</label>
		<pre id="drop_distributed_query"> - "{{event.drop_distributed_query}}"</pre>


        <label for="alter_table_query">Alter Table Query</label>
		<pre ng-repeat="alter_table in event.alter_table_query" id="alter_table_query">
{{ alter_table[0] }}:
 - "{{ alter_table[1] }}"
        </pre>
	</div>
</div>`;
// Exports
module.exports = code;